/* ============
 * Main File
 * ============
 *
 * Will initialize the application.
 */

import Vue from 'vue';

/* ============
 * Plugins
 * ============
 *
 * Import and bootstrap the plugins.
 */

import '@/plugins/vuex';
import '@/plugins/axios';
import { router } from '@/plugins/vue-router';
import '@/plugins/vuex-router-sync';
import { i18n } from '@/plugins/vue-i18n';
import '@/plugins/vuetify';
import { createProvider } from '@/plugins/vue-apollo';
import Keycloak from 'keycloak-js';
import DatetimePicker from 'vuetify-datetime-picker';

/* ============
 * Main App
 * ============
 */

import App from '@/App.vue';
import store from '@/store';

Vue.use(DatetimePicker);

Vue.config.productionTip = false;

const initOptions = {
  realm: process.env.VUE_APP_AUTH_REALM || 'carela',
  'auth-server-url': process.env.VUE_APP_AUTH_ENDPOINT || 'https://carela-auth.devtunnel.org/auth',
  url: process.env.VUE_APP_AUTH_ENDPOINT || 'https://carela-auth.devtunnel.org/auth',
  'ssl-required': 'external',
  resource: process.env.VUE_APP_AUTH_RESOURCE || 'web-app',
  'public-client': true,
  'confidential-port': 0,
  clientId: process.env.VUE_APP_AUTH_CLIENT_ID || 'web-app',
};

const keycloak = Keycloak(initOptions);

/* eslint-disable-next-line */
const keycloakPromise = keycloakPromise => new Promise((resolve, reject) => keycloakPromise
  .success(result => resolve(result))
  .error(e => reject(e)));

/* eslint-disable no-console */
const refreshToken = async () => {
  try {
    const refreshed = await keycloakPromise(keycloak.updateToken(100));
    if (refreshed) {
      if (refreshed) {
        console.log('Token was successfully refreshed');
      } else {
        console.log('Token is still valid');
      }
    }
  } catch (e) {
    console.log('Failed to refresh the token, or the session has expired');
  }
};

// checkLoginIframe fixes infinite reload, check this https://github.com/mauriciovigolo/keycloak-angular/issues/222
keycloakPromise(keycloak.init({ onLoad: 'login-required', checkLoginIframe: false }))
  .then((authenticated) => {
    if (authenticated) {
      store.dispatch('auth/login', keycloak);
      setInterval(refreshToken, 60 * 1000);
      store.dispatch('auth/check');

      /* eslint-disable no-new */
      new Vue({
        /**
          * Bind the Vue instance to the HTML.
          */
        el: '#app',

        /**
          * Internationalisation.
          */
        i18n,

        /**
          * The router.
          */
        router,

        /**
          * The Vuex store.
          */
        store,

        /**
          * Apollo / GraphQL provider
          */
        apolloProvider: createProvider(),

        /**
          * Will render the application.
          *
          * @param {Function} h Will create an element.
          */
        render: h => h(App),
      });
    } else {
      // eslint-disable-next-line no-console
      console.log('Couldn\'t authenticate.');
    }
  })
  .catch(console.error);
